import { useState, useEffect, useRef, useContext } from 'react';
import { AccountIcon, LogoutIcon } from 'features/navigation/assets/icons/icons';
import styles from './MainSidebarAccount.module.css';
import GuiVersion from 'components/shared/gui/GuiVersion';
import LogOut from 'components/shared/gui/LogOut';
import GuiContext from 'config/context/guiContext';

const MainSidebarAccount = ({ collapsed }) => {
    const [showAccountDetails, setShowAccountDetails] = useState(false);
    const accountRef = useRef(null);
    const {
        selected: { selectedAccount, selectedServer },
    } = useContext(GuiContext);

    const handleAvatarClick = (e) => {
        e.stopPropagation();
        if (collapsed) {
            setShowAccountDetails(prev => !prev);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (accountRef.current && !accountRef.current.contains(event.target)) {
                setShowAccountDetails(false);
            }
        };

        if (collapsed && showAccountDetails) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [collapsed, showAccountDetails]);

    useEffect(() => {
        if (!collapsed) {
            setShowAccountDetails(false);
        }
    }, [collapsed]);

    return (
        <div
            ref={accountRef}
            className={`${styles.main_sidebar_account} ${collapsed ? styles.collapsed : ''}`}
        >
            <div className={styles.account_details}>
                <div
                    className={`${styles.account_avatar} ${collapsed ? styles.clickable : ''}`}
                    onClick={handleAvatarClick}
                    role={collapsed ? 'button' : undefined}
                    tabIndex={collapsed ? 0 : undefined}
                    onKeyDown={(e) => {
                        if (collapsed && (e.key === 'Enter' || e.key === ' ')) {
                            e.preventDefault();
                            handleAvatarClick(e);
                        }
                    }}
                >
                    <AccountIcon />
                </div>
                <div className={`${styles.account_info} ${collapsed && showAccountDetails ? styles.show : ''}`}>
                    {(!collapsed || showAccountDetails) && (
                        <>
                            <span>User: {selectedAccount}</span>
                            <span>Server: {selectedServer}</span>
                            {collapsed && showAccountDetails && (
                                <div className={styles.account_info_bottom_line}>
                                    <GuiVersion />
                                    <LogOut />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            {!collapsed && <div className={styles.bottom_line}>
                <GuiVersion />
                <LogOut />
            </div>}
        </div>
    );
};

export default MainSidebarAccount;